<template>
    <Toast />
    <div class="card m-4">
  
      <div class="grid grid-cols-6 gap-4">
  
        <div class="col-span-6">
  
          <div class="card">
            <Toolbar class="mb-4">
              <template #start>
                <Button label="Agregar" icon="pi pi-plus" class="p-button-success mr-2" @click="modal = true"  />
              </template>
              <!-- <template #end>
                <Button label="Exportar" icon="pi pi-upload" class="p-button-help" />
              </template> -->
            </Toolbar>
  
            <DataTable :value="dataModel" paginator :rows="5" :rowsPerPageOptions="[5]" scrollable scrollHeight="400px"
    v-model:editingRows="editingRows" editMode="row" dataKey="idPeriodo" @row-edit-save="onRowEditSave"
    v-model:filters="filters" filterDisplay="row" :loading="loading" tableClass="editable-cells-table">

                <template #header>
                    <div style="text-align: left; display: inline-block;">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filters['global'].value" placeholder="Buscar por Periodo" />
                        </span>
                    </div>
                    &nbsp;
                    <div style="text-align: center; display: inline-block;">
                        <Checkbox v-model="futuros" inputId="campoFuturos" name="futuos" binary @change="completarTabla()"/>
                        <label for="campoFuturos" class="ml-2"> Futuros Periodos </label>
                    </div>
                </template>
                <template #empty> Periodo no encontrado </template>
                <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header" style="width: 150px">
                    <template  #body="{ data, field }">
                        <template v-if="field == 'anulado'">
                            <Checkbox id="chbx" v-model="data[field]" binary aria-describedby="chbx-error" style="width: 100%"/>
                        </template>
                        <template v-else-if=" field != 'vencimiento_1_Original' && field != 'vencimiento_2_Original' && field != 'vencimiento_ProntoPago' ">
                            {{ data[field] }}
                        </template>
                        <template v-else>
                            {{ formatFecha(data[field]) }}
                        </template>
                    </template>
                    <template #editor="{ data, field }">
                      <template v-if="field == 'anulado'">
                            <Checkbox id="chbx" v-model="data[field]" binary aria-describedby="chbx-error" style="width: 100%"/>
                      </template>
                      <template v-else-if="field == 'vencimiento_1_Original' || field == 'vencimiento_2_Original' || field == 'vencimiento_ProntoPago'">
                            <Calendar v-model="data[field]" dateFormat="dd/mm/yy" />
                      </template>
                      <template v-else>
                          <InputText v-model="data[field]" autofocus style="width: 100%"/>
                      </template>
                    </template>
                </Column>
                <Column :rowEditor="true" style="width: 10%; min-width: 8rem" bodyStyle="text-align:center"></Column>
            </DataTable>
          </div>
  
        </div>
  
      </div>

      <div class="card flex justify-content-center">
            <Dialog v-model:visible="modal" modal header="Nuevo Vencimiento" :style="{ width: '50vw' }">
                <div class="align-items-center">
                    <label for="inputPeriodo">Periodo: </label>
                    <Calendar v-model="nuevo.periodo" view="month" dateFormat="mm-yy" />
                </div>
                <br/>
                <div class="align-items-center">
                    <label for="inputNuevoV1">Nuevo Vencimiento: </label>
                    <Calendar v-model="nuevo.vencimiento_1" dateFormat="dd/mm/yy" id="inputNuevoV1" />
                </div>
                <br/>
                <div class="align-items-center">
                    <label for="inputInteres1">Interés 1: </label>
                    <InputNumber v-model="nuevo.interes_1" inputId="inputInteres1" mode="currency" currency="USD" locale="en-US" />
                </div>
                <br/>
                <div class="align-items-center">
                    <label for="inputNuevoV2">Nuevo Vencimiento 2: </label>
                    <Calendar v-model="nuevo.vencimiento_2" dateFormat="dd/mm/yy" id="inputNuevoV2"/>
                </div>
                <br/>
                <div class="align-items-center">
                    <label for="inputInteres2">Interés 2: </label>
                    <InputNumber v-model="nuevo.interes_2" inputId="inputInteres2" mode="currency" currency="USD" locale="en-US" />
                </div>
                <br/>
                <div class="align-items-center">
                    <label for="inputRenglon1">Renglón 1: </label>
                    <InputText id="inputRenglon1" v-model="nuevo.renglon_1" class="p-inputtext-lg"/>
                </div>
                <br/>
                <div class="align-items-center">
                    <label for="inputRenglon2">Renglón 2: </label>
                    <InputText id="inputRenglon2" v-model="nuevo.renglon_2" class="p-inputtext-lg"/>
                </div>
                <br/>
                <div class="align-items-center">
                    <label for="inputRenglon3">Renglón 3: </label>
                    <InputText id="inputRenglon3" v-model="nuevo.renglon_3" class="p-inputtext-lg"/>
                </div>
                <br/>
                <div class="align-items-center">
                    <label for="inputLugarP1">Lugar de Pago 1: </label>
                    <InputText id="inputLugarP1" v-model="nuevo.lugar_de_pago1" class="p-inputtext-lg"/>
                </div>
                <br/>
                <div class="align-items-center">
                    <label for="inputLugarP2">Lugar de Pago 2: </label>
                    <InputText id="inputLugarP2" v-model="nuevo.lugar_de_pago2" class="p-inputtext-lg"/>
                </div>
                <br/>
                <div class="align-items-center">
                    <label for="inputPeriodo">Vencimiento Pronto Pago: </label>
                    <Calendar v-model="nuevo.vencimiento_ProntoPago" dateFormat="dd/mm/yy" />
                </div>
                <br/>
                <!-- <div class="align-items-center">
                    <Checkbox v-model="nuevo.anulado" inputId="checkAnulado" />
                    <label for="checkAnulado" class="ml-2"> Anulado: </label>
                </div> -->
                <template #footer>
                    <Button label="Calcelar" icon="pi pi-times" @click="modal = false" text />
                    <Button label="Guardar" icon="pi pi-check" @click="guardar()" autofocus />
                </template>
            </Dialog>
        </div>
    </div>

    <div class="card flex justify-content-center">
        <Toast position="bottom-center" group="bc">
            <template #message="slotProps">
                <div class="flex flex-column align-items-center" style="flex: 2">
                    <div class="text-center">
                        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
                        <div class="font-bold text-xl my-3">{{ slotProps.message.summary }}</div>
                    </div>
                    <div class="flex gap-2">
                        <Button severity="success" label="Yes" @click="confirmar()"></Button>
                        <Button severity="secondary" label="No" @click="desechar()"></Button>
                    </div>
                </div>
            </template>
        </Toast>
    </div>
    
  </template>
  <script>
    import { ref, onMounted  } from 'vue'
    import { FilterMatchMode } from 'primevue/api'
    import Toolbar from 'primevue/toolbar'
    import Dialog from 'primevue/dialog'
    import DataTable from 'primevue/datatable'
    import Calendar from 'primevue/calendar'
    import Checkbox from 'primevue/checkbox'
    import Button from 'primevue/button'
    import Column from 'primevue/column'
    import InputNumber from 'primevue/inputnumber'
    import InputText from 'primevue/inputtext'
    import Toast from 'primevue/toast'
    import WService from '@/plugins/ws'
    import moment from 'moment'
    import { useToast } from 'primevue/usetoast';
    
    export default {
        components: {
            Button, Column, InputNumber, InputText, Toast, Toolbar, DataTable, Calendar, Checkbox, Dialog,
        },
        setup() {
            onMounted(() => {
                completarTabla();
            })
            const toast = useToast();
            const wService = ref(new WService());
            const dataModel = ref();
            const periodo = ref("");
            const futuros = ref(false);
            const editingRows = ref([]);
            const loading = ref(false);
            const modal = ref(false);
            const filters = ref({
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            });
            const columns = ref([
                { field: 'periodo', header: 'Periodo'},
                { field: 'vencimiento_1_Original', header: '1° Vencimiento'},
                { field: 'interes_1', header: '1° Interés'},
                { field: 'vencimiento_2_Original', header: '2° Vencimiento'},
                { field: 'interes_2', header: '2° Interés'},
                { field: 'renglon_1', header: 'Renglon 1'},
                { field: 'renglon_2', header: 'Renglon 2'},
                { field: 'renglon_3', header: 'Renglon 3'},
                { field: 'lugar_de_pago1', header: 'Lugar de Pago 1'},
                { field: 'lugar_de_pago2', header: 'Lugar de Pago 2'},
                { field: 'anulado', header: 'Anulado'},
                { field: 'vencimiento_ProntoPago', header: 'Vto Pronto Pago'},
            ]);
            const nuevo = ref({ 
                periodo: " ",
                vencimiento_1: " ",
                interes_1: 0,
                vencimiento_2: " ",
                interes_2: 0,
                renglon_1: " ",
                renglon_2: " ",
                renglon_3: " ",
                lugar_de_pago1: " ",
                lugar_de_pago2: " ",
                vencimiento_ProntoPago: " "
                }
            );

            const completarTabla = () => {
                let aux = new Date();
                periodo.value = "0" + (aux.getMonth()+1) + aux.getFullYear();
                periodo.value = aux.getFullYear() + "0" + (aux.getMonth()+1);
                wService.value.getMethod('Vencimientos/' + periodo.value + '/' + futuros.value).then(info => {
                    //console.log(info);
                    if(info.length > 0){
                        dataModel.value = info;
                    }else{
                        toast.add({severity:'error', summary: 'Mensaje de error', detail:'Cuenta Empresa no encontrada', life: 3000});
                    }
                }).catch(err => {
                    console.log(err.message);
                });
            }

            const onRowEditSave = (event) => {
                let { newData, index } = event;
                dataModel.value[index] = newData;
                wService.value.postMethod('Vencimientos/',dataModel.value[index],'put').then(info => {
                    toast.add({severity:'success', summary: 'Mensaje', detail:'Cambios efectuados', life: 3000});
                    completarTabla();
                }).catch(err => {
                    console.log(err.message);
                });
            };

            const formatFecha = value => {
                //console.log(value);
                if (value == null)
                    return " ";
                else
                return value.toString().substring(0, 10);;
            };

           const guardar = (event) => {
                toast.add({ severity: 'warn', summary: 'está seguro  que desea Guardar?', detail: 'Proceed to confirm', group: 'bc' });
            }

            const clearCampos = () => {
                nuevo.value.periodo = " ";
                nuevo.value.vencimiento_1 = " ";
                nuevo.value.interes_1 = 0;
                nuevo.value.vencimiento_2 = " ";
                nuevo.value.interes_2 = 0;
                nuevo.value.renglon_1 = " ";
                nuevo.value.renglon_2 = " ";
                nuevo.value.renglon_3 = " ";
                nuevo.value.lugar_de_pago1 = " ";
                nuevo.value.lugar_de_pago2 = " ";
                nuevo.value.vencimiento_ProntoPago = " ";
            }

            const confirmar = (event) => {
                //console.log(nuevo.value.periodo);
                var data = { 
                    'periodo':   moment(nuevo.value.periodo).format('YYYY-MM'),
                    'vencimiento_1': nuevo.value.vencimiento_1 == " " ? "1900-01-01" : moment(nuevo.value.vencimiento_1).format("YYYY-MM-DD"),
                    'interes_1': nuevo.value.interes_1,
                    'vencimiento_2':  nuevo.value.vencimiento_2 == " " ? "1900-01-01" : moment(nuevo.value.vencimiento_2).format("YYYY-MM-DD"),
                    'interes_2': nuevo.value.interes_2,
                    'renglon_1': nuevo.value.renglon_1  == " " ? "vacio" : nuevo.value.renglon_1,
                    'renglon_2': nuevo.value.renglon_2  == " " ? "vacio" : nuevo.value.renglon_2,
                    'renglon_3': nuevo.value.renglon_3  == " " ? "vacio" : nuevo.value.renglon_3,
                    'lugar_de_pago1': nuevo.value.lugar_de_pago1  == " " ? "vacio" : nuevo.value.lugar_de_pago1,
                    'lugar_de_pago2': nuevo.value.lugar_de_pago2  == " " ? "vacio" : nuevo.value.lugar_de_pago2,
                    'vencimiento_ProntoPago':  nuevo.value.vencimiento_ProntoPago == " " ? "1900-01-01" : moment(nuevo.value.vencimiento_ProntoPago).format("YYYY-MM-DD")
                };
                //console.log(data);
                wService.value.getMethod('Vencimientos/Guardar/'+ data.periodo+'/'+data.vencimiento_1+'/'+data.interes_1+'/'
                    +data.vencimiento_2+'/'+data.interes_2+'/'+data.renglon_1+'/'+data.renglon_2+'/'+data.renglon_3
                    +'/'+data.lugar_de_pago1+'/'+data.lugar_de_pago2+'/'+data.vencimiento_ProntoPago).then(info => {
                    if(info == "OK"){
                        toast.removeGroup('bc');
                        completarTabla();
                        clearCampos();
                        modal.value = false;
                        toast.add({severity:'success', summary: 'Mensaje exitoso', detail:'Nota de credito guardada', life: 5000});
                    }else{
                        toast.add({severity:'error', summary: 'Mensaje de error', detail:'Error al guardar nota de credito', life: 5000});
                    }
                }).catch(err => {
                    console.log(err.message);
                });
            }

            const desechar = (event) => {
                clearCampos();
            } 

            return {
                dataModel, columns, periodo, futuros, editingRows, loading, filters, modal, nuevo,

                completarTabla, onRowEditSave, formatFecha, guardar, confirmar, desechar, clearCampos,
            };
        },
    }
  </script>